 /**
  * plat：
  * 0-云端(默认)  
  * 1、2、3、4、5...  本地镜像
  * */

 /**
  * 
  */
export const env = '/readermain'; //三新本地服务器环境
// export const env = '/ttreader';  //云服务器环境

export const plat = 0;  //学校平台

export const orgCustoms = [{
    "index": 0,
    "plat": 0,
    "orgName": null,
    "orgId": null,
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "login": "../../assets/images/loginlogo.png",
    "IP": "http://viewery.ytzhihui.com",
    "codeUrl": "http://wapready.ytzhihui.com"
}, { 
    "index": 1,
    "plat": 1,
    "orgName": "贺州市职业教育发展中心图书馆",
    "orgId": "2418",
    "loginBgName": "logo_bj_HZ",
    "loginBg": "@/assets/images/themes/logo_bj_HZ.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://172.16.58.158:89", 
    "codeUrl": "http://172.16.58.158:81"
},{
    "index": 2,
    "plat": 2,
    "orgName":"广东食品药品职业学校",
    "orgId": "4541",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://192.168.0.134:89", 
    "codeUrl": "http://192.168.0.134:81"
},{
    "index": 3,
    "plat": 3,
    "orgName":"鄂州职业大学图书馆",
    "orgId": "3984",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://172.19.40.3:89", 
    "codeUrl": "http://172.19.40.3:81"
},{
    "index": 4,
    "plat": 4,
    "orgName":"鄂州职业大学图书馆",
    "orgId": "3984",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://172.19.40.3/reader", 
    "codeUrl": "http://172.19.40.3:81"
},{
    "index": 5,
    "plat": 5,
    "orgName":"广西民族大学",
    "orgId": "4764",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://210.36.69.38:89",
    "codeUrl": "http://210.36.69.38:81"
},{
    "index": 6,
    "plat": 6,
    "orgName":"广西建设职业技术学院",
    "orgId": "4787",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://172.16.5.9:89",
    "codeUrl": "http://172.16.5.9:81"
},{
    "index": 7,
    "plat": 7,
    "orgName":"江苏卫生健康职业学院",
    "orgId": "5864",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://192.168.73.35:89",
    "codeUrl": "http://192.168.73.35:81"
},{
    "index": 8,
    "plat": 8,
    "orgName":"徐州医科大学",
    "orgId": "2449",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://223.2.160.153:89",
    "codeUrl": "http://223.2.160.153:81"
},{
    "index": 9,
    "plat": 9,
    "orgName":"河南科技大学",
    "orgId": "3728",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://192.168.100.207:89",
    "codeUrl": "http://192.168.100.207:81"
},{
    "index": 10,
    "plat": 10,
    "orgName":"宜州区高级中学",
    "orgId": "2485",
    "loginBgName": "login_bg",
    "loginBg":"../../assets/images/login_bg.jpg",
    "loginLogo":"@/assets/images/loginlogo.png",
    "IP":"http://192.168.105.5:89",
    "codeUrl": "http://192.168.105.5:81"
},{
    "index": 11,
    "plat": 11,
    "orgName": "上海建桥学院图书馆",
    "orgId": "2135",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.16.27.150:89",
    "codeUrl": "http://172.16.27.150:81"
},{
    "index": 12,
    "plat": 12,
    "orgName": "广西建设职业技术学院图书馆",
    "orgId": "4787",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.16.5.9:89",
    "codeUrl": "http://172.16.5.9:81"
},{
    "index": 13,
    "plat": 13,
    "orgName": "广西建设职业技术学院图书馆",
    "orgId": "4787",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.16.4.104:89",
    "codeUrl": "http://172.16.4.104:81"
},{
    "index": 14,
    "plat": 14,
    "orgName": "辽宁工程技术大学",
    "orgId": "1713",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://10.11.23.17:89",
    "codeUrl": "http://10.11.23.17:81"
},{
    "index": 15,
    "plat": 15,
    "orgName": "陕西青年职业学院",
    "orgId": "5350",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://10.215.1.138:89",
    "codeUrl": "http://10.215.1.138:81"
},{
    "index": 16,
    "plat": 16,
    "orgName": "漳州卫生职业学院图书馆",
    "orgId": "3144",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.16.1.94:89",
    "codeUrl": "http://172.16.1.94:81"
},{
    "index": 17,
    "plat": 17,
    "orgName": "重庆化工职业学院图书馆",
    "orgId": "4862",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.24.100.171:89",
    "codeUrl": "http://172.24.100.171:81"
},{
    "index": 18,
    "plat": 18,
    "orgName": "天津渤海职业技术学院图书馆",
    "orgId": "1187",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://192.168.1.252:89",
    "codeUrl": "http://192.168.1.252:81"
}, {
    "index": 19,
    "plat": 19,
    "orgName": "辽宁师范大学图书馆",
    "orgId": "1761",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://210.47.221.2:89",
    "codeUrl": "http://210.47.221.2:81"
}, {
    "index": 20,
    "plat": 20,
    "orgName": "江西工业贸易职业技术学院图书馆",
    "orgId": "3434",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://10.100.200.205:89",
    "codeUrl": "http://10.100.200.205:81"
}, {
    "index": 21,
    "plat": 21,
    "orgName": "内蒙古科技大学包头师范学院",
    "orgId": "1569",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://192.168.116.43:89",
    "codeUrl": "http://192.168.116.43:81"
}, {
    "index": 22,
    "plat": 22,
    "orgName": "陕西交通职业技术学院图书馆",
    "orgId": "5414",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://172.17.1.29:89",
    "codeUrl": "http://172.17.1.29:81"
},{
    "index": 23,
    "plat": 23,
    "orgName": "南昌职业大学图书馆",
    "orgId": "3431",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://192.168.1.231:89",
    "codeUrl": "http://192.168.1.231:81"
},{
    "index": 24,
    "plat": 24,
    "orgName": "青岛恒星科技学院图书馆",
    "orgId": "3590",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://192.168.8.220:89",
    "codeUrl": "http://192.168.8.220:81"
},{
    "index": 25,
    "plat": 25,
    "orgName": "锦州医科大学图书馆",
    "orgId": "5826",
    "loginBgName": "login_bg",
    "loginBg": "../../assets/images/login_bg.jpg",
    "loginLogo": "@/assets/images/loginlogo.png",
    "IP": "http://10.8.3.19:89",
    "codeUrl": "http://10.8.3.19:81"
}] 



// WEBPACK FOOTER //
// ./src/dataJson/custom.js